import { render, staticRenderFns } from "./404-page.vue?vue&type=template&id=e22bdd00&scoped=true&lang=pug&"
import script from "./404-page.vue?vue&type=script&lang=ts&"
export * from "./404-page.vue?vue&type=script&lang=ts&"
import style0 from "./404-page.vue?vue&type=style&index=0&id=e22bdd00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22bdd00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
